// extracted by mini-css-extract-plugin
export default {"header_panel":"HeaderPanel-module--header_panel--8Zj4u"};